module.exports = __webpack_public_path__ + "static/eDWBBG-05ca261063e107030f5c30fd41c79a99.png";